import React from 'react';
import { Highlight, Snippet } from 'react-instantsearch-dom';
import Link from '../link-page';

export const PageHit = (clickHandler) => ({ hit }) => (
  <div>
    <Link targetId={hit.contentful_id} onClick={clickHandler}>
       <Highlight attribute="title" hit={hit} tagName="mark" />
    </Link>&nbsp;-&nbsp;
    <Snippet attribute="seoDescription" hit={hit} tagName="mark"/>
  </div>
);
